module.exports = __webpack_public_path__ + "img/logo-white.f05d67a3.svg";